module.exports = __webpack_public_path__ + "img/owner_habitation.f75ca892.png";